webpackJsonp([93803410282108],{

/***/ 798:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"highlight_banner":"src-components-HighlightBanner----HighlightBanner-module---highlight_banner---331Wm","highlight_image":"src-components-HighlightBanner----HighlightBanner-module---highlight_image---3zvWu","highlight_text":"src-components-HighlightBanner----HighlightBanner-module---highlight_text---1gBDS","order_1":"src-components-HighlightBanner----HighlightBanner-module---order_1---1TL64","order_2":"src-components-HighlightBanner----HighlightBanner-module---order_2---3POhJ","h3":"src-components-HighlightBanner----HighlightBanner-module---h3---n46bf","h4":"src-components-HighlightBanner----HighlightBanner-module---h4---27KJ1","hr":"src-components-HighlightBanner----HighlightBanner-module---hr---138Lv","section":"src-components-HighlightBanner----HighlightBanner-module---section---kEjqN","images":"src-components-HighlightBanner----HighlightBanner-module---images---2H2pq","more":"src-components-HighlightBanner----HighlightBanner-module---more---3uyUh","more_open":"src-components-HighlightBanner----HighlightBanner-module---more_open---j-ClQ src-components-HighlightBanner----HighlightBanner-module---more---3uyUh","more_closed":"src-components-HighlightBanner----HighlightBanner-module---more_closed---Q5e3D src-components-HighlightBanner----HighlightBanner-module---more---3uyUh","more_wrapper":"src-components-HighlightBanner----HighlightBanner-module---more_wrapper---1ZrnJ","more_wrapper_open":"src-components-HighlightBanner----HighlightBanner-module---more_wrapper_open---ie10K src-components-HighlightBanner----HighlightBanner-module---more_wrapper---1ZrnJ","more_wrapper_closed":"src-components-HighlightBanner----HighlightBanner-module---more_wrapper_closed---2Lx3F src-components-HighlightBanner----HighlightBanner-module---more_wrapper---1ZrnJ"};

/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HighlightBannerModule = __webpack_require__(798);
	
	var _HighlightBannerModule2 = _interopRequireDefault(_HighlightBannerModule);
	
	var _plusMinus = __webpack_require__(243);
	
	var _plusMinus2 = _interopRequireDefault(_plusMinus);
	
	var _reactScroll = __webpack_require__(48);
	
	var _gatsbyImage = __webpack_require__(30);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function createMarkup(value) {
		return {
			__html: value
		};
	}
	
	var HighlightBanner = function (_Component) {
		_inherits(HighlightBanner, _Component);
	
		function HighlightBanner(props) {
			_classCallCheck(this, HighlightBanner);
	
			var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
			_this.handleToggle = function () {
				if (_this.state.open) {
					_reactScroll.scroller.scrollTo(_this.props.title, {
						duration: 500,
						delay: 0,
						smooth: true,
						offset: -150 // Scrolls to element + 50 pixels down the page
					});
				}
	
				_this.setState({ open: !_this.state.open });
			};
	
			_this.state = {
				open: false
			};
			return _this;
		}
	
		HighlightBanner.prototype.render = function render() {
			var props = this.props;
	
			return _react2.default.createElement(
				"div",
				{
					className: _HighlightBannerModule2.default.highlight_banner + " " + props.className,
					style: props.style
				},
				_react2.default.createElement(
					"div",
					{ className: "container " },
					_react2.default.createElement(
						_reactScroll.Element,
						{
							name: props.title,
							className: "element mb-3 mb-lg-0"
						},
						_react2.default.createElement(
							"div",
							{
								className: "row " + (props.contentAlign || "justify-content-md-center")
							},
							_react2.default.createElement(
								"div",
								{
									className: _HighlightBannerModule2.default.highlight_image + " " + (props.contentAlign === "start" ? _HighlightBannerModule2.default.order_2 : _HighlightBannerModule2.default.order_1)
								},
								_react2.default.createElement(_gatsbyImage2.default, {
									title: props.image.title,
									alt: props.image.title,
									sizes: props.image.sizes
								})
							),
							_react2.default.createElement(
								"div",
								{
									className: _HighlightBannerModule2.default.highlight_text + " " + (props.contentAlign === "start" ? _HighlightBannerModule2.default.order_1 : _HighlightBannerModule2.default.order_2),
									style: _extends({}, props.style)
								},
								_react2.default.createElement(
									"div",
									null,
									_react2.default.createElement(
										"h3",
										{ className: _HighlightBannerModule2.default.h3 },
										props.title
									),
									_react2.default.createElement("hr", { className: _HighlightBannerModule2.default.hr }),
									_react2.default.createElement("div", {
										dangerouslySetInnerHTML: createMarkup(props.description.content.html)
									})
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{
							className: "row " + (props.contentAlign === "start" ? "justify-content-start " : "justify-content-lg-end ") + (this.state.open ? _HighlightBannerModule2.default.more_wrapper_open : _HighlightBannerModule2.default.more_wrapper_closed)
						},
						_react2.default.createElement(
							"div",
							{
								className: _HighlightBannerModule2.default.images + " " + (this.state.open ? _HighlightBannerModule2.default.more_open : _HighlightBannerModule2.default.more_closed),
								style: {
									order: props.contentAlign === "start" ? "2" : "1"
								}
							},
							props.gallery && props.gallery.length > 0 && props.gallery.map(function (item, i) {
								return _react2.default.createElement(_gatsbyImage2.default, {
									key: "image-" + i,
									title: item.title,
									alt: item.title,
									sizes: item.sizes
								});
							})
						),
						_react2.default.createElement(
							"div",
							{
								className: "col-lg-6 " + _HighlightBannerModule2.default.section + " " + (this.state.open ? _HighlightBannerModule2.default.more_open : _HighlightBannerModule2.default.more_closed),
								style: {
									order: props.contentAlign === "start" ? "1" : "2"
								}
							},
							props.details && props.details.length > 0 && props.details.map(function (item, i) {
								return _react2.default.createElement(
									"div",
									{ key: "detail-" + i },
									_react2.default.createElement(
										"h4",
										{ className: _HighlightBannerModule2.default.h4 },
										item.title
									),
									_react2.default.createElement("div", {
										dangerouslySetInnerHTML: createMarkup(item.content.content.html)
									})
								);
							})
						),
						_react2.default.createElement(
							"div",
							{
								className: "col-12 d-flex " + (props.contentAlign === "start" ? "justify-content-end justify-content-lg-start" : "justify-content-end"),
								style: { padding: "0 5%", order: "3" }
							},
							_react2.default.createElement(_plusMinus2.default, {
								contentAlign: props.contentAlign,
								state: this.state.open,
								toggle: this.handleToggle
							})
						)
					)
				)
			);
		};
	
		return HighlightBanner;
	}(_react.Component);
	
	exports.default = HighlightBanner;
	module.exports = exports["default"];

/***/ }),

/***/ 803:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"stat_row":"src-components-StatBar----StatBar-module---stat_row---6NdVv","stat":"src-components-StatBar----StatBar-module---stat---1cfN8","description":"src-components-StatBar----StatBar-module---description---1Rjkp"};

/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StatBarModule = __webpack_require__(803);
	
	var _StatBarModule2 = _interopRequireDefault(_StatBarModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderStats = function renderStats() {
		var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	
		return array.map(function (item, i) {
			function createMarkup() {
				return {
					__html: item.description.content.html
				};
			}
			return _react2.default.createElement(
				"div",
				{ key: "stat-" + i, className: "col-12 col-md-4 text-center" },
				_react2.default.createElement(
					"b",
					{ className: _StatBarModule2.default.stat },
					item.title
				),
				_react2.default.createElement(
					"p",
					{ className: _StatBarModule2.default.description },
					item.text
				),
				_react2.default.createElement("div", { className: _StatBarModule2.default.description, dangerouslySetInnerHTML: createMarkup() })
			);
		});
	};
	
	var StatBar = function (_Component) {
		_inherits(StatBar, _Component);
	
		function StatBar() {
			_classCallCheck(this, StatBar);
	
			return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		}
	
		StatBar.prototype.render = function render() {
			return _react2.default.createElement(
				"div",
				{ className: _StatBarModule2.default.stat_bar },
				_react2.default.createElement(
					"div",
					{ className: "container" },
					_react2.default.createElement(
						"div",
						{ className: "row " + _StatBarModule2.default.stat_row },
						renderStats(this.props.stats)
					)
				)
			);
		};
	
		return StatBar;
	}(_react.Component);
	
	exports.default = StatBar;
	module.exports = exports["default"];

/***/ }),

/***/ 282:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"circle_plus":"src-components-plus-minus----PlusMinus-module---circle_plus---aoUcN","circle":"src-components-plus-minus----PlusMinus-module---circle---UYUKf","circle_open":"src-components-plus-minus----PlusMinus-module---circle_open---2gyDJ src-components-plus-minus----PlusMinus-module---circle---UYUKf","without_label":"src-components-plus-minus----PlusMinus-module---without_label---2RhSS","horizontal":"src-components-plus-minus----PlusMinus-module---horizontal---1aFze","vertical":"src-components-plus-minus----PlusMinus-module---vertical---3ZnHe","vertical_closed":"src-components-plus-minus----PlusMinus-module---vertical_closed---16RFK src-components-plus-minus----PlusMinus-module---vertical---3ZnHe","horizontal_closed":"src-components-plus-minus----PlusMinus-module---horizontal_closed---ekOG2 src-components-plus-minus----PlusMinus-module---horizontal---1aFze","vertical_open":"src-components-plus-minus----PlusMinus-module---vertical_open---nTcHN src-components-plus-minus----PlusMinus-module---vertical---3ZnHe","horizontal_open":"src-components-plus-minus----PlusMinus-module---horizontal_open---6GvWJ src-components-plus-minus----PlusMinus-module---horizontal---1aFze"};

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PlusMinusModule = __webpack_require__(282);
	
	var _PlusMinusModule2 = _interopRequireDefault(_PlusMinusModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlusMinus = function PlusMinus(props) {
		return _react2.default.createElement(
			"div",
			{ className: _PlusMinusModule2.default.circle_plus, onClick: function onClick() {
					return props.toggle();
				} },
			_react2.default.createElement(
				"div",
				{ className: props.state ? (props.label && _PlusMinusModule2.default.without_label) + " " + _PlusMinusModule2.default.circle_open : (props.label && _PlusMinusModule2.default.without_label) + " " + _PlusMinusModule2.default.circle },
				_react2.default.createElement("div", {
					className: props.state ? _PlusMinusModule2.default.horizontal_open : _PlusMinusModule2.default.horizontal_closed
				}),
				_react2.default.createElement("div", {
					className: props.state ? _PlusMinusModule2.default.vertical_open : _PlusMinusModule2.default.vertical_closed
				}),
				props.label && _react2.default.createElement(
					"span",
					{ style: props.contentAlign === "start" ? { position: "absolute", width: "250%", left: "-250%", top: "50%", transform: "translateY(-50%)" } : { position: "absolute", width: "250%", right: "-275%", top: "50%", transform: "translateY(-50%)" } },
					props.label
				)
			)
		);
	};
	
	exports.default = PlusMinus;
	module.exports = exports["default"];

/***/ }),

/***/ 806:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"h3":"src-styles----capabilities-module---h3---2EbVs","h4":"src-styles----capabilities-module---h4---3TcW3","section":"src-styles----capabilities-module---section---181FC","images":"src-styles----capabilities-module---images---1Odfd"};

/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Jumbotron = __webpack_require__(17);
	
	var _Jumbotron2 = _interopRequireDefault(_Jumbotron);
	
	var _CallToAction = __webpack_require__(38);
	
	var _CallToAction2 = _interopRequireDefault(_CallToAction);
	
	var _StatBar = __webpack_require__(660);
	
	var _StatBar2 = _interopRequireDefault(_StatBar);
	
	var _PageWrapper = __webpack_require__(21);
	
	var _PageWrapper2 = _interopRequireDefault(_PageWrapper);
	
	var _capabilitiesModule = __webpack_require__(806);
	
	var _capabilitiesModule2 = _interopRequireDefault(_capabilitiesModule);
	
	var _HighlightBanner = __webpack_require__(655);
	
	var _HighlightBanner2 = _interopRequireDefault(_HighlightBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Capability = function Capability(_ref) {
		var data = _ref.data,
		    transition = _ref.transition,
		    location = _ref.location;
		var page_title = data.allMvruJson.edges[0].node.capability.page_title;
	
	
		var pageSettings = data.contentfulCapabilityPage;
		var stats = data.stats.edges;
		var cta = data.cta.edges[0].node;
		var capabilities = data.capability.edges;
	
		return _react2.default.createElement(
			_PageWrapper2.default,
			{ locale: pageSettings.node_locale, location: location, data: data.layout.edges[0].node },
			_react2.default.createElement(
				"main",
				{ role: "main", style: transition && transition.style },
				_react2.default.createElement(_reactHelmet2.default, { title: pageSettings.pageTitle + " | Mahidol Vivax Research Unit" }),
				_react2.default.createElement(
					_Jumbotron2.default,
					{
						type: "jumbotron_b",
						bottomLine: "true",
						className: "mb-0",
						textAlign: "text-center",
						contentAlign: "justify-content-md-center"
					},
					_react2.default.createElement(
						"h1",
						null,
						pageSettings.pageTitle
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "container my-lg-5" },
					capabilities.map(function (_ref2, i) {
						var node = _ref2.node;
	
						return _react2.default.createElement(
							"div",
							{ key: i + 1, className: "mb-5" },
							_react2.default.createElement(_HighlightBanner2.default, {
								contentAlign: i % 2 > 0 ? "start" : "end",
								image: node.featuredImage,
								title: node.title,
								description: node.leadingParagraph,
								details: node.subsections,
								gallery: node.gallery
							}),
							i === 0 && _react2.default.createElement(_StatBar2.default, {
								stats: [stats[0].node, stats[1].node, stats[2].node]
							}),
							i === 1 && _react2.default.createElement(_StatBar2.default, {
								stats: [stats[3].node, stats[4].node, stats[5].node]
							})
						);
					})
				),
				_react2.default.createElement(
					"div",
					{ className: "grey_bg" },
					_react2.default.createElement(_CallToAction2.default, {
						className: "py-5",
						leadText: cta.leadingText,
						text: cta.content.childMarkdownRemark.html,
						buttonLabel: cta.buttonLabel,
						destination: "/" + pageSettings.node_locale + cta.linkTo,
						arrow: true
					})
				)
			)
		);
	};
	
	exports.default = Capability;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-capability-template-js-4e21b27b242ad9972169.js